<template>
  <el-form label-width="120px" :inline="true" :model="form" class="demo-form-inline">
    <el-form-item label="手机号" required>
      <el-input v-model="form.phone" placeholder="多个手机号英文逗号分隔" clearable />
    </el-form-item>

    <el-form-item label="奖品" required>
      <el-select v-model="form.raffle_id" placeholder="请选择奖品" clearable>
        <el-option v-for="item in raffleOptions" :key="item.id" :label="`${item.title}（${item.words || item.money}）`" :value="item.id" />
      </el-select>
    </el-form-item>
  </el-form>
</template>

<script setup>
import { ref, onMounted, nextTick, getCurrentInstance } from 'vue'

const form = ref({
  phone: '',
  raffle_id: '',
})
const props = defineProps(['item'])
const raffleOptions = ref([])
const { proxy } = getCurrentInstance()

onMounted(async () => {
  nextTick(() => {
    form.value = Object.assign(form.value, props.item)
  })
  await loadRaffles()
})

const loadRaffles = async () => {
  const res = await proxy.$http({
    method: 'get',
    url: '/Raffle/getRaffleLists',
    params: {
      page: 1,
      limit: 1000,
    }
  })
  if (res.code === 0) {
    raffleOptions.value = res.data.data || []
  }
}

defineExpose({ form })
</script>

<style lang="less" scoped>
.demo-form-inline {
  justify-content: flex-start;
  display: flex;
  flex-wrap: wrap;
}
.demo-form-inline .el-input { --el-input-width: 220px; }
.demo-form-inline .el-select { --el-select-width: 220px; }
</style>